// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__2_NdA","loading__block":"styles_loading__block__43u4n","loading__skeleton":"styles_loading__skeleton__AxI91"};